import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import { TextField, MenuItem, Button, Typography, InputAdornment, IconButton, Tooltip } from '@mui/material';
import { red } from '@mui/material/colors';
import classNames from 'classnames';
import MailingHeaderAdvanceFilterBox from './MailingHeaderAdvanceFilterBox';
// import { MailingHeaderGroupFilterBox } from './Groups/MailingHeaderGroupFilterBox';
import SearchIcon from '@mui/icons-material/Search';

const useStyles = makeStyles(theme => ({
    root: {
        //padding: '2px 4px',
        display: 'flex',
        alignItems: 'flex-start',
        width: '100%',
        justifyContent: 'flex-end',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(0.5),
    },
    inputRow: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
    },
    dropdownsWrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    dropdownsRow: {
        display: 'flex',
        alignItems: 'flex-start',
    },
    filterBySelect: {
        //width: '22%',
        //paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    searchBox: {
        //width: '40%',
        //paddingLeft: theme.spacing(0),
        paddingRight: theme.spacing(1),
    },
    resetButton: {
        marginTop: theme.spacing(0.5),
        //width: '38%',
        //paddingLeft: theme.spacing(1),
        //paddingRight: theme.spacing(1)
    },
    advanceFiltersRow: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0.5),
    },
    textField: {
        width: '100%'
    },
    redColorResetButton: {
        color: '#b82525',
        border: '#b82525',
        marginTop: '4px',
        cursor: 'pointer',
        fontWeight: 500,
        //color: 'white',
        '&:hover': {
            color: '#b82525',
            border: '#b82525',
            textDecoration: 'underline'
            //color: 'white',
        }
    },
    resetButtonMarginLeft: {
        marginLeft: theme.spacing(0.5)
    },
    // filterByBoxExtraWidth: {
    //     width: '113%'
    // }
    searchButton: {
        padding: '8px 8px',
        minWidth: '32px',
        marginTop: '3px'
    },
    startIconButton: {
        padding: 0,
        margin: 0
    },
    flashButton: {
        animation: "$new-blinker-sb 2s linear 20",
        animationDuration: '2s',
        '&:hover': {
            animation: '0',
            WebkitAnimation: 0
        }
    },
    "@keyframes new-blinker-sb ": {
        "85%": {
            opacity: 0
        }
    },
}));

export const MailingHeaderSearchBox = (props) => {
    const classes = useStyles();
    const filterByOption = [
        { id: 'all', label: 'Total' },
        { id: 'active', label: 'Unblocked' },
        { id: 'blocked', label: 'Blocked' },
        { id: 'delete', label: 'Deleted' },
        { id: 'duplicateMailingAddress', label: 'Duplicate Mailing Addresses' },
        { id: 'homeValuation', label: 'Home Valuations' },
        { id: "condoBlocked", label: "Blocked Condos" },
    ];
    const { onSearchChange, onResetClick, onFilterClick, hoSearch, hoFilter, showDeleteFilter, showDuplicateMailingAddressFilter, countHOMap, isDataLoading } = props;
    const [filterValue, setFilterValue] = useState("active");
    const [searchValue, setSearchValue] = useState("");
    const [inputWidth, setInputWidth] = useState('300');

    useEffect(() => {
        setSearchValue(hoSearch);
    }, [hoSearch]);

    useEffect(() => {
        setFilterValue(hoFilter);
    }, [hoFilter]);

    const handleLocalFilterClick = (event) => {
        setFilterValue(event.target.value);
        setTimeout(() => {
            onFilterClick(event);
        }, 200);
    };

    const handleLocalSearchValue = (event) => {
        setTimeout(() => {
            onSearchChange(searchValue);
        }, 200);
    };

    const handleLocalReset = (event) => {
        setFilterValue('active');
        setSearchValue('');
        setTimeout(() => {
            onResetClick(event);
        }, 200);
    };

    const getFilterByOptionLabel = () => {
        const option = filterByOption.find(option => option.id === hoFilter);
        return option ? (option.label === 'Total' ? 'All' : option.label) : '';
    }

    return (
        <div>
            <div className={classes.root}>
                {/* <MailingHeaderGroupFilterBox /> */}
                <div className={classes.inputRow}>
                    <div className={classes.dropdownsWrapper}>
                        <div className={classes.dropdownsRow}>
                            <div className={classes.filterBySelect}>
                                <TextField
                                    id="outlined-select-filterby"
                                    select
                                    label="Filter By"
                                    placeholder="Filter By"
                                    className={classNames(classes.textField, classes.filterByBoxExtraWidth)}
                                    fullWidth
                                    value={filterValue}
                                    onChange={event => handleLocalFilterClick(event)}
                                    margin="dense"
                                    size="small"
                                    disabled={isDataLoading}
                                    SelectProps={{
                                        MenuProps: {
                                            className: classes.menu,
                                        },
                                    }}
                                    variant="outlined"
                                >
                                    {filterByOption.map(option => (
                                        //hide delete for other agent
                                        (((option.id === 'delete' && !showDeleteFilter) || (option.id === 'duplicateMailingAddress' && !showDuplicateMailingAddressFilter)) ? '' :
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.label} ({countHOMap[option.id]})
                                            </MenuItem>
                                        )
                                    ))}
                                </TextField>
                            </div>
                            <div className={classes.searchBox}>
                                <TextField
                                    id="standard-name"
                                    label="Search Mailing List"
                                    placeholder="Search Mailing List"
                                    className={classes.textField}
                                    value={searchValue}
                                    onChange={event => { setSearchValue(event.target.value) }}
                                    variant="outlined"
                                    margin="dense"
                                    size="small"
                                    disabled={isDataLoading}
                                />
                            </div>
                        </div>
                        <div className={classes.advanceFiltersRow}>
                            <MailingHeaderAdvanceFilterBox {...props} currentHOFilterLabel={getFilterByOptionLabel()} />
                        </div>
                    </div>
                    <div className={classes.resetButton}>
                        <Tooltip title="Search anything in MailPro">
                            <span>
                                <Button
                                    onClick={event => handleLocalSearchValue(event)}
                                    color="primary"
                                    variant="contained"
                                    className={classes.searchButton}
                                    startIcon={<SearchIcon fontSize='small' />}
                                    classes={{
                                        startIcon: classes.startIconButton
                                    }}
                                    disabled={isDataLoading}
                                />
                            </span>
                        </Tooltip>
                        {/* <Button
                            onClick={event => handleLocalSearchValue(event)}
                            color="primary"
                            variant="contained"
                        >Search</Button> */}
                        {/* &nbsp; */}
                        {searchValue ?
                            <div
                                onClick={event => handleLocalReset(event)}
                                className={classNames(classes.redColorResetButton, classes.flashButton)}
                            //className={searchValue ? classNames(classes.redColor, classes.resetButtonMarginLeft) : classes.resetButtonMarginLeft}
                            >
                                Reset
                            </div>
                            : ''}
                    </div>
                </div>
            </div>
        </div>
    );
}
